export const TOKENS = {
  ACCESS_TOKEN: "4Play_web_access_token",
  REFRESH_TOKEN: "4Play_web_refresh_token",
};

export const countries = [
  { value: "AND", label: "Andorra" },
  { value: "ARG", label: "Argentina" },
  { value: "AUS", label: "Australia" },
  { value: "AUT", label: "Austria" },
  { value: "BEL", label: "Belgium" },
  { value: "BWA", label: "Botswana" },
  { value: "BVT", label: "Bouvet Island" },
  { value: "BRA", label: "Brazil" },
  { value: "BRN", label: "Brunei" },
  { value: "BGR", label: "Bulgaria" },
  { value: "CAN", label: "Canada" },
  { value: "CHN", label: "China" },
  { value: "CXR", label: "Christmas Island" },
  { value: "CCK", label: "Cocos Islands" },
  { value: "COL", label: "Colombia" },
  { value: "COK", label: "Cook Islands" },
  { value: "CZE", label: "Czech Republic" },
  { value: "DNK", label: "Denmark" },
  { value: "FRO", label: "Faroe Islands" },
  { value: "FIN", label: "Finland" },
  { value: "FRA", label: "France" },
  { value: "GUF", label: "French Guiana" },
  { value: "ATF", label: "French Southern Territories" },
  { value: "DEU", label: "Germany" },
  { value: "GRC", label: "Greece" },
  { value: "GRL", label: "Greenland" },
  { value: "GLP", label: "Guadeloupe" },
  { value: "HMD", label: "Heard Island and McDonald Islands" },
  { value: "HKG", label: "Hong Kong" },
  { value: "HUN", label: "Hungary" },
  { value: "ISL", label: "Iceland" },
  { value: "IND", label: "India" },
  { value: "IDN", label: "Indonesia" },
  { value: "IRN", label: "Iran" },
  { value: "IRL", label: "Ireland" },
  { value: "ISR", label: "Israel" },
  { value: "ITA", label: "Italy" },
  { value: "JPN", label: "Japan" },
  { value: "KAZ", label: "Kazakhstan" },
  { value: "KIR", label: "Kiribati" },
  { value: "LIE", label: "Liechtenstein" },
  { value: "LUX", label: "Luxembourg" },
  { value: "MYS", label: "Malaysia" },
  { value: "MTQ", label: "Martinique" },
  { value: "MUS", label: "Mauritius" },
  { value: "MYT", label: "Mayotte" },
  { value: "MEX", label: "Mexico" },
  { value: "MCO", label: "Monaco" },
  { value: "NRU", label: "Nauru" },
  { value: "NPL", label: "Nepal" },
  { value: "NLD", label: "Netherlands" },
  { value: "NZL", label: "New Zealand" },
  { value: "NIU", label: "Niue" },
  { value: "NFK", label: "Norfolk Island" },
  { value: "NOR", label: "Norway" },
  { value: "OMN", label: "Oman" },
  { value: "PAK", label: "Pakistan" },
  { value: "PSE", label: "Palestinian Territory" },
  { value: "PHL", label: "Philippines" },
  { value: "PCN", label: "Pitcairn" },
  { value: "POL", label: "Poland" },
  { value: "PRT", label: "Portugal" },
  { value: "QAT", label: "Qatar" },
  { value: "REU", label: "Reunion" },
  { value: "ROU", label: "Romania" },
  { value: "RUS", label: "Russia" },
  { value: "SPM", label: "Saint Pierre and Miquelon" },
  { value: "SMR", label: "San Marino" },
  { value: "SAU", label: "Saudi Arabia" },
  { value: "SGP", label: "Singapore" },
  { value: "SVN", label: "Slovenia" },
  { value: "ZAF", label: "South Africa" },
  {
    value: "SGS",
    label: "South Georgia and the South Sandwich Islands",
  },
  { value: "KOR", label: "South Korea" },
  { value: "ESP", label: "Spain" },
  { value: "LKA", label: "Sri Lanka" },
  { value: "SJM", label: "Svalbard and Jan Mayen" },
  { value: "SWE", label: "Sweden" },
  { value: "CHE", label: "Switzerland" },
  { value: "TWN", label: "Taiwan" },
  { value: "THA", label: "Thailand" },
  { value: "TKL", label: "Tokelau" },
  { value: "TTO", label: "Trinidad and Tobago" },
  { value: "TUR", label: "Turkey" },
  { value: "TUV", label: "Tuvalu" },
  {
    value: "USA",
    label: "United States",
  },
  { value: "GBR", label: "United Kingdom" },
  { value: "VAT", label: "Vatican" },
  { value: "VEN", label: "Venezuela" },
];

export const occupations = [
  {
    value: "STUDENT",
    label: "Student",
  },
  { value: "EMPLOYEE", label: "Employee" },
  { value: "SELF_EMPLOYED", label: "Self Employed" },
  { value: "OTHER", label: "Other" },
];

export const PLAN_TYPE_VS_PRICE = {
  TRIAL: 0,
  RADIO: 29,
  UNLIMITED: 79,
};

export const personalOccupations = [
  { value: "Art Gallery", label: "Art Gallery" },
  { value: "Bakery", label: "Bakery" },
  { value: "Bar", label: "Bar" },
  { value: "Barber Shop", label: "Barber Shop" },
  { value: "Bookstore", label: "Bookstore" },
  { value: "Car Dealership", label: "Car Dealership" },
  { value: "Casino", label: "Casino" },
  { value: "Clothing Boutique", label: "Clothing Boutique" },
  { value: "Coffee Shop", label: "Coffee Shop" },
  { value: "Convenience Store", label: "Convenience Store" },
  { value: "Co-working Space", label: "Co-working Space" },
  { value: "Dental Clinic", label: "Dental Clinic" },
  { value: "Dentist/Doctor's Office", label: "Dentist/Doctor's Office" },
  { value: "Fast Food", label: "Fast Food" },
  { value: "Furniture Store", label: "Furniture Store" },
  { value: "Gym/Fitness Center", label: "Gym/Fitness Center" },
  { value: "Hair Salon", label: "Hair Salon" },
  { value: "Hotel", label: "Hotel" },
  { value: "Jewelry Store", label: "Jewelry Store" },
  { value: "Lounge", label: "Lounge" },
  { value: "Museum", label: "Museum" },
  { value: "Office", label: "Office" },
  { value: "Pool or Beach Club", label: "Pool or Beach Club" },
  { value: "Private Club", label: "Private Club" },
  { value: "Restaurant", label: "Restaurant" },
  { value: "Retail Store", label: "Retail Store" },
  { value: "Shopping Mall", label: "Shopping Mall" },
  { value: "Spa", label: "Spa" },
  { value: "Supermarket", label: "Supermarket" },
  { value: "Tattoo Parlor", label: "Tattoo Parlor" },
  { value: "Theater", label: "Theater" },
  { value: "Wellness Center", label: "Wellness Center" },
  { value: "Other", label: "Other" },
];
